import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TransportOrderContainerCostRecord } from "types/command.types";
import { v4 as uuid } from "uuid";

interface TransportOrderContainerCostState {
  list: TransportOrderContainerCostRecord[];
}

const initialState: TransportOrderContainerCostState = {
  list: [],
};

const transportOrderContainerCostSlice = createSlice({
  name: "transportOrderContainerCost",
  initialState,
  reducers: {
    // Load từ API
    setCostList(
      state,
      action: PayloadAction<TransportOrderContainerCostRecord[]>
    ) {
      state.list = action.payload;
    },

    // Thêm dòng mới
    addCost(state) {
      state.list.push({
        key: uuid(),
        costType: "",
        quantity: 1,
        unitPrice: 0,
        currency: "VND",
        isNew: true,
        isEditing: true,
        costCode: "",
        note: "",
      });
    },

    // Update 1 dòng
    updateCost(
      state,
      action: PayloadAction<{
        key: string;
        changes: Partial<TransportOrderContainerCostRecord>;
      }>
    ) {
      const item = state.list.find(
        (row : TransportOrderContainerCostRecord) => row.key === action.payload.key
      );
      if (item) {
        Object.assign(item, action.payload.changes);

        // auto tính total
        if (
          action.payload.changes.quantity !== undefined ||
          action.payload.changes.unitPrice !== undefined
        ) {
          item.total =
            (item.quantity ?? 0) * (item.unitPrice ?? 0);
        }
      }
    },

    // Xoá dòng
    removeCost(state, action: PayloadAction<string>) {
      state.list = state.list.filter(
        (row : TransportOrderContainerCostRecord) => row.key !== action.payload
      );
    },

    // Clear khi đổi container
    clearCostList(state) {
      state.list = [];
    },
  },
});

export const {
  setCostList,
  addCost,
  updateCost,
  removeCost,
  clearCostList,
} = transportOrderContainerCostSlice.actions;

export default transportOrderContainerCostSlice.reducer;
